  <template>
  <!-- <v-container fluid class="white">
      <v-layout align-center justify-center row fill-height>
        <v-flex class="cdp-title text-center ml-auto mr-auto">
          <h1 class="">Common people</h1>
          <h1 class="">Common things</h1>
          <h1 class=""><b>Common day</b></h1>
        </v-flex>
      </v-layout>
    </v-container> -->

  <v-app class="white background">
    <Content>
      <!-- <div id="home" class="ml-auto mr-auto text-left cdp-title" :style="image">
        <h1 class="mx-auto">Common people</h1>
        <h1 class="mx-auto">Common things</h1>
        <h1 class="mx-auto"><b>Common day</b></h1>
      </div> -->
    </Content>
    <Footer />
  </v-app>
</template>

  <script>
import Content from "@/components/Content";
import Footer from "@/components/Footer";

export default {
  components: {
    Content,
    Footer,
  },

  data() {
    return {
      image: { backgroundImage: "../assets/background-min.png" },
    };
  },
};
</script>

  <style scoped media="screen">
.background {
  background: url("../assets/background-min.png") no-repeat center center fixed;
  background-size: 40%;
}

@media (min-width: 300px) {
  .background {
    background-size: 90%;
  }
}

@media (min-width: 500px) {
  .background {
    background-size: 80%;
  }
}

@media (min-width: 850px) {
  .background {
    background-size: 35%;
  }
}
</style>
